import React from 'react';
import Warning from "../../warning";
import Verbiage from '../../verbiage.js';

function BackorderedDetails({details, dateRange, expectItDate}){

    return(
        <div>
            {
                details.isBackordered && !expectItDate &&
                <Warning>
                        <span className="dai_detailsMessageBackordered" >
                            {Verbiage.BACKORDERED_NO_DATE_FIRST_HALF}
                        </span>                         
                        <span className="u__bold">
                            backordered
                        </span>
                        <span className="dai_detailsMessageBackordered" >
                            {Verbiage.BACKORDERED_NO_DATE_SECOND_HALF}
                        </span>
                </Warning>
            }
            {
                details.isBackordered && expectItDate &&
                <Warning>
                    <span>
                        {Verbiage.BACKORDERED_DATE_FIRST_HALF}
                        <span className="u__bold">
                            {Verbiage.BACKORDERED_DATE_BOLD}
                        </span>
                        {Verbiage.BACKORDERED_DATE_SECOND_HALF}
                    </span>
                </Warning>
            }
        </div>
    );
}
export default BackorderedDetails;
